(() => {
  const initialize = (root) => {
    if (root.dataset.acArtworkMegaReady === "true") return;

    const triggers = Array.from(root.querySelectorAll("[data-ac-artwork-trigger]"));
    const panels = Array.from(root.querySelectorAll("[data-ac-artwork-panel]"));
    const defaultPanel = root.querySelector('[data-ac-artwork-panel="default"]');

    if (!triggers.length || !defaultPanel) return;

    const activate = (requestedKey) => {
      const requestedPanel = panels.find((panel) => panel.dataset.acArtworkPanel === requestedKey);
      const activePanel = requestedPanel || defaultPanel;
      const activeKey = activePanel.dataset.acArtworkPanel;

      panels.forEach((panel) => {
        panel.hidden = panel !== activePanel;
      });

      triggers.forEach((trigger) => {
        trigger.dataset.active = String(trigger.dataset.acArtworkTrigger === activeKey);
      });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("pointerenter", () => activate(trigger.dataset.acArtworkTrigger));
      trigger.addEventListener("focusin", () => activate(trigger.dataset.acArtworkTrigger));
    });

    const disclosure = root.closest("details");
    disclosure?.addEventListener("toggle", () => {
      if (!disclosure.open) activate("default");
    });

    root.addEventListener("pointerleave", () => activate("default"));
    root.addEventListener("ac:artwork-panel", (event) => activate(event.detail?.key || "default"));
    root.dataset.acArtworkMegaReady = "true";
    activate("default");
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll("[data-ac-artwork-mega]").forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
  document.addEventListener("shopify:block:select", (event) => {
    const panel = event.target.closest?.("[data-ac-artwork-panel]");
    const root = event.target.closest?.("[data-ac-artwork-mega]");

    if (panel && root) {
      root.dispatchEvent(new CustomEvent("ac:artwork-panel", { detail: { key: panel.dataset.acArtworkPanel } }));
    }
  });
})();
